export default __webpack_public_path__ + "1.18.19/static/media/close.2fccb63b.svg";